import { useState, useEffect } from 'react';
import warn from '../utils/warn.js';

/**
 * Returns whether a the input in a form will validate when it is submitted, without having to submit it.
 *
 * @param inputElementRef The input ref to listen to for validity changes
 * @param onBlur Optional onBlur callback
 */
function useCheckValidity(inputElementRef, onBlur) {
  const [isNativeValid, setIsNativeValid] = useState(true);

  // Listen to when the input changes and set `isNativeValid`
  useEffect(() => {
    const inputElement = inputElementRef.current;
    if (!inputElement) {
      warn("No input element found");
      return () => {};
    }
    function handleBlurEvent(ev) {
      const inputEl = ev.target;
      if (onBlur) {
        onBlur(ev);
      }
      setIsNativeValid(inputEl.checkValidity());
    }
    inputElement.addEventListener("blur", handleBlurEvent);
    return () => inputElement.removeEventListener("blur", handleBlurEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputElementRef]);
  return isNativeValid;
}

export { useCheckValidity };
